import { Typography } from '@material-ui/core';
import React from 'react';

export const TradeInCTA = () => {
  return (
    <div
      style={{
        marginBottom: 32,
        color: '#fff',
      }}
    >
      <Typography
        variant='h4'
        component='h1'
        gutterBottom
        style={{ fontWeight: 800, color: '#fff', letterSpacing: 0.5 }}
      >
        Quanto vale la tua auto?
      </Typography>
      <Typography
        variant='body1'
        gutterBottom
        style={{ marginBottom: 12, color: '#e0e0e0' }}
      >
        Compila i campi con le informazioni della tua vettura e ti forniremo
        <strong> una stima accurata e senza impegno.</strong>
        <br />
        <span style={{ fontWeight: 500 }}>
          La valutazione sarà valida esclusivamente come permuta sull’acquisto
          di questa vettura.
        </span>
        <br />
        Il nostro team ti guiderà in ogni fase per aiutarti a scegliere la
        soluzione più vantaggiosa per te.
      </Typography>
      <ul
        style={{
          margin: 0,
          paddingLeft: 24,
          marginBottom: 0,
          color: '#fff',
          fontSize: 17,
          fontWeight: 500,
          listStyle: 'disc',
        }}
      >
        <li style={{ marginBottom: 4 }}>Valutazione professionale</li>
        <li style={{ marginBottom: 4 }}>Impegno</li>
        <li>Possibilità di integrazione immediata nell'acquisto</li>
      </ul>
    </div>
  );
};
